module.exports = __webpack_public_path__ + "img/080.c737ab38.jpg";